export * from "./telemetry-button";
import TelemetryButton from "./telemetry-button";
export default TelemetryButton;
